/**
 * Calculates the retail savings as a percentage.  Returns as 33, not 0.33.
 *
 * In the event that retail price is 0 or purchasePrice is less than or equal to retail price, 0 is returned.
 * @param {number} retailPrice The retail price of the product.
 * @param {number} purchasePrice The price you are comparing the retail price to.
 * @returns {number} Returns as 33, not 0.33.
 */
const calculateRetailSavings = (retailPrice: number, purchasePrice: number): number => {
  if (retailPrice === 0 || retailPrice <= purchasePrice) return 0;
  else {
    return ((retailPrice - purchasePrice) / retailPrice) * 100;
  }
};

export default calculateRetailSavings;
